export const SPARK_SWIPE_DELTA_THRESHOLD = 75